<template>
<div>
  <el-row style="height: 100vh">
    <el-col :xs="24" :sm="24" :md="24" :lg="20" :xl="20" class="main-container">
      <el-col v-if="verificationState === 'email_only'" :span="24" class="broker-list-container">

        <el-col id="container-email-verification" :xs="22" :sm="22" :md="22" :lg="14" :xl="14" class="form-container">
          <el-col :span="24" class="card-header" style="text-align: center;">

            <img v-if="current_logo" :src="current_logo" class="email-verification-logo">
            <a v-else href="https://www.smartcharts.net/" class="smartchart-logo">
              <object :data="smartchart_logo" type="image/svg+xml"></object>
            </a>
            <!-- <a href="https://www.smartcharts.net/" class="smartchart-logo">

              <img :src="logo" class="email-verification-logo" />
            </a> -->
          </el-col>
          <el-form id="form-email-verification" ref="ruleForm" :model="ruleForm" label-width="120px">

            <el-col :span="24" class="form-container_">
              <h1>Thank you for verifying your email address.</h1>
              <p style="  font-size: 18px;font-weight: 500;">
                We still need to confirm that the trading account number you have given us is associated with the email address.
                <br><br>
                Once this has been done, we’ll email to tell you it is complete.
              </p>
              <!-- <p style="  font-size: 18px;font-weight: 500;">An email verification has been sent to <strong> {{ registration_email }} </strong></p> -->
            </el-col>

            <el-col :span="24" style="text-align: center; margin-top: 20px; padding-top: 40px; float: none;">
              <el-col :span="24" style="text-align: center;  float: none;">
                <el-button size="large" @click="handleProceed('ruleForm')" type="success">LOGIN TO YOUR ACCOUNT</el-button>
                <!-- <el-button size="large" @click="handleLogout('ruleForm')" type="success">LOGOUT</el-button> -->
                <!-- <el-button size="large" @click="handleProceed('ruleForm')" type="success">PROCEED TO SMART CHARTS</el-button> -->

              </el-col>

            </el-col>
          </el-form>

        </el-col>

      </el-col>

      <el-col v-if="verificationState === 'both_verified'" :span="24" class="broker-list-container">

        <el-col id="container-email-verification" :xs="22" :sm="22" :md="22" :lg="14" :xl="14" class="form-container">
          <el-col :span="24" class="card-header" style="text-align: center;">
            <a href="https://www.smartcharts.net/" class="smartchart-logo">
              <!-- <object data="https://login.smartcharts.xyz/img/logo.svg" type="image/svg+xml"></object> -->
              <img :src="logo" class="email-verification-logo" />
            </a>
          </el-col>
          <el-form id="form-email-verification" ref="ruleForm" :model="ruleForm" label-width="120px">

            <el-col :span="24" class="form-container_">
              <h1>Your SmartChartsaccount is ready with SmartCharts.</h1>
              <p style="  font-size: 18px;font-weight: 500;">
                <!-- We still need to confirm that the trading account number you have given us is associated with the email address.
            <br><br>
             Once this has been done, we’ll email to tell you it is complete. -->
              </p>
              <!-- <p style="  font-size: 18px;font-weight: 500;">An email verification has been sent to <strong> {{ registration_email }} </strong></p> -->
            </el-col>

            <el-col :span="24" style="text-align: center; margin-top: 20px; padding-top: 40px; float: none;">
              <el-col :span="24" style="text-align: center;  float: none;">
                <el-button size="large" @click="handleProceed('ruleForm')" type="success">LOGIN TO YOUR ACCOUNT</el-button>
                <!-- <el-button size="large" @click="handleLogout('ruleForm')" type="success">LOGOUT</el-button> -->
                <!-- <el-button size="large" @click="handleProceed('ruleForm')" type="success">PROCEED TO SMART CHARTS</el-button> -->

              </el-col>

            </el-col>
          </el-form>

        </el-col>

      </el-col>

      <el-col v-if="verificationState === 'account_only'" :span="24" class="broker-list-container">

        <el-col id="container-email-verification" :xs="22" :sm="22" :md="22" :lg="14" :xl="14" class="form-container">
          <el-col :span="24" class="card-header" style="text-align: center;">
            <a href="https://www.smartcharts.net/" class="smartchart-logo">
              <!-- <object data="https://login.smartcharts.xyz/img/logo.svg" type="image/svg+xml"></object> -->
              <img :src="logo" class="email-verification-logo" />
            </a>
          </el-col>
          <el-form id="form-email-verification" ref="ruleForm" :model="ruleForm" label-width="120px">

            <el-col :span="24" class="form-container_">
              <h1>Enable to Login</h1>
              <p style="  font-size: 18px;font-weight: 500;">
                We are unable to log you in because you have not verified your email address.
                <br>
                <br>If you cannot find your verification email, please contact us at <a href="mailto:info@smartchartsfx.com" style="color: #fff">info@smartchartsfx.com</a>

              </p>
              <!-- <p style="  font-size: 18px;font-weight: 500;">An email verification has been sent to <strong> {{ registration_email }} </strong></p> -->
            </el-col>

            <el-col :span="24" style="text-align: center; margin-top: 20px; padding-top: 40px; float: none;">
              <el-col :span="24" style="text-align: center;  float: none;">
                <el-button size="large" @click="handleProceed('ruleForm')" type="success">LOGIN TO YOUR ACCOUNT</el-button>
                <!-- <el-button size="large" @click="handleLogout('ruleForm')" type="success">LOGOUT</el-button> -->
                <!-- <el-button size="large" @click="handleProceed('ruleForm')" type="success">PROCEED TO SMART CHARTS</el-button> -->

              </el-col>

            </el-col>
          </el-form>

        </el-col>

      </el-col>

    </el-col>
  </el-row>
</div>
</template>

<script>
export default {
  name: 'EmailVerification',
  props: {
    registration_email: {
      type: String,
      required: true
    },
  },
  data() {
    return {
      active_lang: 'en',
      logo: require('@/assets/logo_collections/CI_logo.webp'),
      email_verified: true,
      account_verified: false,
      expires_at: '',
      user: '',
      signature: '',
      final_url: '',
      current_logo: '',
      broker_list: [{
          id: '1',
          logo: require('@/assets/logo_collections/CI_logo.webp'),
          name: 'capitalindex',
          current_account: '243678',
          status: 'Active',
          type: 'current',
          options: {
            foreign_exchange: true,
            crypto: true,
            metals: true,
            indices: true,
          }
        },
        {
          id: '2',
          logo: require('@/assets/logo_collections/sc_logo_white.webp'),
          name: 'smartcharts',
          current_account: '213352',
          status: 'Active',
          type: 'other',
          options: {
            foreign_exchange: true,
            crypto: true,
            metals: true,
            indices: true,
          }
        },
        {
          id: '3',
          logo: require('@/assets/logo_collections/errante_logo.webp'),
          name: 'Errante',
          current_account: '213352',
          status: 'Active',
          type: 'other',
          options: {
            foreign_exchange: true,
            crypto: true,
            metals: true,
            indices: true,
          }
        },
        {
          id: '4',
          logo: require('@/assets/logo_collections/tickmill.webp'),
          name: 'Tickmill',
          current_account: '989721',
          status: 'Active',
          type: 'other',
          options: {
            foreign_exchange: true,
            crypto: true,
            metals: true,
            indices: true,
          }
        },
        {
          id: '5',
          logo: require('@/assets/logo_collections/ic_markets.webp'),
          name: 'Markets',
          current_account: '215543',
          status: 'Pending',
          type: 'other',
          options: {
            foreign_exchange: true,
            crypto: true,
            metals: true,
            indices: true,
          }
        },
        {
          id: '6',
          logo: require('@/assets/logo_collections/pepperstone.webp'),
          name: 'Pepperstone',
          current_account: '123700',
          status: 'Pending',
          type: 'available',
          options: {
            foreign_exchange: true,
            crypto: true,
            metals: false,
            indices: false,
          }
        },
        {
          id: '7',
          logo: require('@/assets/logo_collections/vt_markets.webp'),
          name: 'vt markets',
          current_account: '123701',
          status: 'Pending',
          type: 'available',
          options: {
            foreign_exchange: true,
            crypto: true,
            metals: true,
            indices: true,
          }
        },
        {
          id: '8',
          logo: require('@/assets/logo_collections/think_markets.png'),
          name: 'Think Markets',
          current_account: '213353',
          status: 'Active',
          type: 'other',
          options: {
            foreign_exchange: true,
            crypto: true,
            metals: true,
            indices: true,
          }
        },
        {
          id: '9',
          logo: require('@/assets/logo_collections/markets_com.png'),
          name: 'Markets.com',
          current_account: '813357',
          status: 'Active',
          type: 'other',
          options: {
            foreign_exchange: true,
            crypto: true,
            metals: true,
            indices: true,
          }
        },
        {
          id: '10',
          logo: require('@/assets/logo_collections/intertrader.png'),
          name: 'InterTrader',
          current_account: '813358',
          status: 'Active',
          type: 'other',
          options: {
            foreign_exchange: true,
            crypto: true,
            metals: true,
            indices: true,
          }
        },
      ]


    }
  },
  created() {

  },
  mounted() {
    const queryParams = this.verifyEmailFromParams();
    const bParam = this.$route.query.broker
    if(bParam) {
      this.getLogo()
    }
    console.log(queryParams);
  },
  computed: {
    verificationState() {
      if (this.email_verified && this.account_verified) {
        return 'both_verified';
      } else if (this.email_verified && !this.account_verified) {
        return 'email_only';
      } else if (!this.email_verified && this.account_verified) {
        return 'account_only';
      } else {
        return 'none_verified';
      }
    }
  },
  methods: {
    getLogo() {
        let bParam = this.$route.query.broker
          ? this.$route.query.broker.toLowerCase().replace(/\s+/g, '')
          : ''

        let matchedBroker = this.broker_list.find(broker => {
          const normalizedName = broker.name.toLowerCase().replace(/\s+/g, '')
          return normalizedName === bParam
        })

        if (matchedBroker) {
          this.current_logo = matchedBroker.logo
        }
    },
    async verifyEmailFromParams() {
      const axios = require('axios');
      // Extract query params from the URL
      const params = new URLSearchParams(window.location.search);

      let data = {
        expires: params.get('expires'),
        user: params.get('user'),
        signature: params.get('signature')
      };

      // Save individual values if needed
      this.expires_at = data.expires;
      this.user = data.user;
      this.signature = data.signature;

      // Build URL with query parameters
      const url = process.env.VUE_APP_API_URL  + `/v1/user/verify/email?expires=${data.expires}&user=${data.user}&signature=${data.signature}`;

      try {
        const response = await axios.get(url, {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          withCredentials: false
        });

        const _new_data = response.data;
        this.final_url = _new_data.login_url
        // if (_new_data.login_url) {
        //   setTimeout(() => {
        //     window.location.href = _new_data.login_url;
        //   }, 5000);

        // }
        // Store token in cookies
        // this.$cookies.set('session_token', session_details.token);
        // this.$cookies.set('expires_at', session_details.expires_at);

        console.log("Email verification successful:", _new_data);
      } catch (error) {
        this.loading = false;
        this.logout();
        console.error("Error verifying email:", error.response?.data || error.message);
      }
    },

    handleProceed() {
      window.location.href = this.final_url;
    }
  },

}
</script>

<style scoped>
img.email-verification-logo {
  width: 200px;
}

#form-email-verification {
  padding: 50px 60px 40px 60px;
}

#container-email-verification .card-header {
  margin-top: 30px;
}

span.el-radio-button__inner {
  color: #a2b0d5 !important;
  border: 1px solid #7e85aa !important;
  background-color: transparent !important;
}

.form-container {
  /* padding: 40px; */

  float: none;
}

.el-radio-button__inner {
  color: #a2b0d5 !important;
  border: 1px solid #7e85aa !important;
  background-color: transparent !important;

}

label.el-radio-button.is-active {
  background-color: #ffffff2b;
}

.steps {
  height: 5px;
  border-radius: 10px;
  background-color: transparent;
  border: 1px solid #ffffff59;
  margin-right: 5px;
  width: 32% !important;
}

.green_ {
  background-color: #a4f14a;
  color: #a4f14a;
}

.red_ {
  background-color: #ff6c6c;
  color: #ff6c6c;
}

.yellow_ {

  background-color: #ffd077;
  color: #ffd077;
}

.green_text {
  color: #a4f14a;
}

.form-container[data-v-7cb4def3] {
  /* padding: 40px; */

  margin-bottom: 40px;
}

.main-container {
  float: none !important;
  margin: 0 auto !important;
  color: #ffffff !important;
  padding-top: 10vh;
}

.broker-list-wrapper {
  text-align: left;
}

.broker-list-wrapper h2 {
  font-weight: 300;
  font-size: 22px;
  margin-top: 40px;
  margin-bottom: 20px;
}

.broker-list-item {
  /* background-color: #3c4f6d; */
  transition: box-shadow 0.3s ease;
  background: linear-gradient(to right, #3f4f75, #3f3b5e);
  padding: 20px;
  display: flex;
  border-radius: 5px;
  height: 30px;
}

.logo_container img {
  /* width: 60px; */
  margin-left: 40px;
  width: auto;
  height: 30px;
}

.logo_container {}

.part-2 p,
.part-3 p,
.part-divider p {
  margin-block-start: 0px !important;
  margin-block-end: 0px !important;
  padding-top: 5px;
}

.part-2 p {
  color: #ffffff80;
}

.part-2 p strong {
  color: #ffffff;
}

.part-divider {
  text-align: center;
  color: #ffffff3d;
}

.broker-list-item.active {
  box-shadow: inset 0px 0px 0px 1px #93ca85;
}

.item-icon {
  transform: rotate(180deg) !important;
  color: #ffffff80;
  font-size: 20px;
  margin-left: 20px;
}

.dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  float: left;
  margin-top: 10px;
  margin-right: 5px;
}

.green {
  background-color: #93ca85;
}

.yellow {
  background-color: #e2ca5d;
}

.broker-list-item {
  margin-bottom: 10px;
}

.part-4 {
  float: right;
  text-align: center;

}

.broker-list-item:hover {
  box-shadow: inset 0px 0px 0px 1px #93ca85;
}

.item-btn {
  float: right;
  text-align: center;
  box-shadow: inset 0px 0px 0px 1px #93ca85;
  padding: 5px 40px;
  border-radius: 3px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.item-btn:hover {
  background-color: #93ca855c;
  transition: background-color 0.3s ease;
}

.darkBlue {
  background: #283a5d !important;
  width: 13%;
  margin-right: 5px;
  display: inline-block;
  box-shadow: inset 0px 0px 0px 1px #93ca85;
}

.available-types-title {
  text-align: center;
  color: #ffffffb3;
}

.available-icon-true {
  border-radius: 50%;
  /* background-color: #93ca85; */
  background-color: #5a954b;
  padding: 3px;
}

.available-icon-false {
  border-radius: 50%;
  /* background-color: #ea7374; */
  background-color: #e44f51;
  font-weight: bold;
  padding: 3px;
}

.item-btn.btn-apply {
  padding: 5px 24px;
}

.available-item-check-container {
  border-right: 1px solid #ffffff3d;
  margin-top: 5px;
}

.available-item-check-container.end {
  border-right: none !important;
}

.page-subtitle {
  color: #adc0ff;
  font-size: 20px;
}

.logo-icon-container {
  margin-left: -10px;
  display: flex;
  align-items: center;
  align-content: center;
  margin-top: -5px;
}

.available-broker-wrapper {
  padding-bottom: 10vh;
}

.available-broker-wrapper h2 {
  margin-bottom: 0px !important;
}

.broker-item-list {
  box-shadow: 1px 2px 3px #00000021;

}

.form-container_ {
  float: none;
  text-align: center;
}

form.el-form {
  margin-top: 0px;
}
</style>
